import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'material-ui/styles/withStyles';
import styles from './styles';
import {FILE_TYPE_VIDEO, FILE_TYPE_PDF} from '../../../common/types';

const Tile = props => {
	const {
		item, handleOpenFile, poster, classes
	} = props;

	const PreviewIcon = () => {
		let icon;

		switch (item.type) {
			case FILE_TYPE_VIDEO:
				icon = '/assets/play.svg';
				break;
			case FILE_TYPE_PDF:
				icon = '/assets/pdf.svg';
				break;
			default:
				icon = false;
		}

		/* TODO discuss:
		 * maybe it better to use css in order to improove
		 * performance at big lists of files, but I'm not sure
		 * how is it important */
		return icon ? (<img className={classes.posterIcon} src={icon} alt=""/>) : ('');
	};

	const PosterComponent = poster ?
		(<div className={classes.poster} style={{backgroundImage: `url(${poster})`}}/>) :
		(<PreviewIcon/>);

	const type = item.type === FILE_TYPE_PDF ? 'PDF' : 'Video';

	return (
		<div className={classes.container} onClick={handleOpenFile}>
			<div className={classes.preview}>
				{PosterComponent}
			</div>

			<div className={classes.label}>
				<p className={classes.type}>{type}</p>
				<h3 className={classes.title}>{item.name}</h3>
			</div>
		</div>
	);
};

Tile.propTypes = {
	item: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,
	handleOpenFile: PropTypes.func.isRequired,
	poster: PropTypes.string
};

export default withStyles(styles)(Tile);



// WEBPACK FOOTER //
// ./src/client/components/main/files/tile/tile.jsx